import { useCallback } from "react";
import { useSelector } from "react-redux";

import { selectRoles, userDocIdSelector } from "app/modules/auth/selectors";
import {
  selectSelectedSchool,
  userPrimaryRoleSelector,
  userNameSelector,
  sideBarOptionsSelector,
  selectSession,
  selectActiveSession,
} from "app/modules/schools/selectors";

import { BETA_URL, buildSSOUrl } from "app/utils/beta";

/**
 * Opens the v2 (beta) ERP in a new tab, carrying the current session across so
 * the user never has to log in again. Shared by the header button and the
 * daily awareness popup.
 */
const useBetaLaunch = () => {
  const userDocId = useSelector(userDocIdSelector);
  const roles = useSelector(selectRoles);
  const username = useSelector(userNameSelector);
  const selectedSchool = useSelector(selectSelectedSchool);
  const primaryRole = useSelector(userPrimaryRoleSelector);
  const menuOptionsToShow = useSelector(sideBarOptionsSelector);
  const sessionList = useSelector(selectSession);
  const activeSession = useSelector(selectActiveSession);

  const launchBeta = useCallback(() => {
    const url = buildSSOUrl({
      userDocId,
      username,
      roles,
      selectedSchool,
      primaryRole,
      menuOptionsToShow,
      sessionList,
      activeSession,
    });
    window.open(url || BETA_URL, "_blank", "noopener,noreferrer");
  }, [
    userDocId,
    username,
    roles,
    selectedSchool,
    primaryRole,
    menuOptionsToShow,
    sessionList,
    activeSession,
  ]);

  return { launchBeta, userDocId };
};

export default useBetaLaunch;
